import { create } from 'zustand';

const useRootCauseStore = create((set) => ({
  rootCauses: [],
  loading: false,
  error: null,

  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  columnFilters: {},
  uniqueValues: {},

  selectedRootCause: null,
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  rootCauseToDelete: null,

  setRootCauses: (rootCauses) => set({ rootCauses }),

  setPagination: (paginationData) => set((state) => ({
    paginationData: { ...state.paginationData, ...paginationData }
  })),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setColumnFilters: (filters) => set((state) => ({
    columnFilters: typeof filters === 'function' ? filters(state.columnFilters) : filters
  })),

  setUniqueValues: (values) => set((state) => ({
    uniqueValues: { ...state.uniqueValues, ...values }
  })),

  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedRootCause: null
  }),

  openEditForm: (rootCause) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedRootCause: rootCause
  }),

  closeForm: () => set({
    isFormOpen: false,
    isEditMode: false,
    selectedRootCause: null
  }),

  openDeleteDialog: (rootCause) => set({
    isDeleteDialogOpen: true,
    rootCauseToDelete: rootCause
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    rootCauseToDelete: null
  }),

  reset: () => set({
    rootCauses: [],
    loading: false,
    error: null,
    columnFilters: {},
    selectedRootCause: null,
    isFormOpen: false,
    isDeleteDialogOpen: false
  })
}));

export { useRootCauseStore };
export default useRootCauseStore;
